import React, { useEffect, useMemo } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import {
  ChevronRight,
  Clock,
  Calendar,
  User,
  Share2,
  ArrowLeft,
  CheckCircle,
  ThumbsUp,
  Bookmark
} from "react-feather";
import { BLOG_POSTS } from "./blogData";
import "./Blogs.css";

const BlogDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  // Find post matching id or slug
  const post = useMemo(() => {
    return (
      BLOG_POSTS.find((item) => item.id === id) ||
      BLOG_POSTS.find((item) => item.id === "what-is-audit-interview") ||
      BLOG_POSTS[0]
    );
  }, [id]);

  // Related articles (excluding current article)
  const relatedArticles = useMemo(() => {
    return BLOG_POSTS.filter((item) => item.id !== post.id).slice(0, 3);
  }, [post]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [id]);

  const handleShare = () => {
    if (navigator.share) {
      navigator.share({
        title: post.title,
        url: window.location.href
      });
    } else {
      navigator.clipboard.writeText(window.location.href);
      alert("Link copied to clipboard!");
    }
  };

  return (
    <div className="blog-detail-wrapper">
      <div className="container" style={{ maxWidth: "1000px" }}>
        {/* Breadcrumb */}
        <div className="blog-breadcrumb">
          <Link to="/">Home</Link>
          <ChevronRight size={14} />
          <Link to="/blogs">Blogs & Career Resources</Link>
          <ChevronRight size={14} />
          <span style={{ color: "#333", fontWeight: 600 }}>{post.category}</span>
        </div>

        {/* Back Link */}
        <button
          onClick={() => navigate("/blogs")}
          style={{
            background: "none",
            border: "none",
            color: "var(--blog-primary)",
            fontWeight: 600,
            cursor: "pointer",
            display: "inline-flex",
            alignItems: "center",
            gap: 6,
            marginBottom: 15,
            padding: 0
          }}
        >
          <ArrowLeft size={16} /> Back to all articles
        </button>

        {/* Header Section */}
        <div className="blog-detail-header">
          <span className="featured-badge">{post.category}</span>
          <h1 className="blog-detail-title">{post.title}</h1>

          <div className="blog-detail-meta">
            <div className="author-info-badge">
              <div>
                <span className="author-name">{post.author.name}</span>
                <span className="author-role">{post.author.role}</span>
              </div>
            </div>

            <div style={{ display: "flex", alignItems: "center", gap: 15, marginLeft: "auto" }}>
              <span style={{ display: "flex", alignItems: "center", gap: 4 }}>
                <Calendar size={15} /> {post.date}
              </span>
              <span style={{ display: "flex", alignItems: "center", gap: 4 }}>
                <Clock size={15} /> {post.readTime}
              </span>
              <button
                onClick={handleShare}
                style={{
                  background: "#ffffff",
                  border: "1px solid #ebd9c8",
                  padding: "6px 12px",
                  borderRadius: "20px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: 6,
                  fontSize: "0.82rem",
                  color: "var(--blog-primary)",
                  fontWeight: 600
                }}
              >
                <Share2 size={14} /> Share
              </button>
            </div>
          </div>
        </div>

        {/* Main Article Image */}
        <div
          style={{
            borderRadius: "16px",
            overflow: "hidden",
            marginBottom: "30px",
            maxHeight: "450px"
          }}
        >
          <img
            src={post.image}
            alt={post.title}
            style={{ width: "100%", maxHeight: "450px", objectFit: "cover", objectPosition: "top" }}
          />
        </div>

        {/* Article Body Content */}
        <div
          className="blog-content-body"
          dangerouslySetInnerHTML={{ __html: post.content }}
        />



        {/* Author Bio Box */}
        <div
          style={{
            background: "#ffffff",
            borderRadius: "16px",
            border: "1px solid var(--blog-border-color)",
            padding: "25px",
            display: "flex",
            alignItems: "center",
            gap: 20,
            marginBottom: "40px"
          }}
        >
          <div>
            <span style={{ fontSize: "0.75rem", textTransform: "uppercase", color: "var(--blog-primary)", fontWeight: 700 }}>
              Written By
            </span>
            <h4 style={{ fontSize: "1.1rem", fontWeight: 700, margin: "2px 0 4px" }}>
              {post.author.name}
            </h4>
            <p style={{ fontSize: "0.88rem", color: "#666", margin: 0 }}>
              {post.author.role} at BetelJobs. Dedicated to delivering high-impact field compliance insights, career guides, and technical audit preparation.
            </p>
          </div>
        </div>

        {/* Related Articles Section */}
        <div style={{ marginTop: "40px" }}>
          <h2 className="section-title" style={{ marginBottom: "20px" }}>
            Related Articles
          </h2>
          <div className="articles-grid" style={{ gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))" }}>
            {relatedArticles.map((rel) => (
              <div
                key={rel.id}
                className="blog-card"
                onClick={() => navigate(`/blog/${rel.id}`)}
              >
                <div className="blog-card-img-wrapper">
                  <img src={rel.image} alt={rel.title} />
                </div>
                <div className="blog-card-body">
                  <div className="blog-card-category">{rel.category}</div>
                  <h3 className="blog-card-title">{rel.title}</h3>
                  <div className="blog-card-footer">
                    <span>{rel.date}</span>
                    <span>{rel.readTime}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogDetail;
